import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
  inject,
} from '@angular/core';
import { SpenFlashMessage, SpenLink } from '@classi/spen';
import { LoginStatusMessageService } from './login-status-message.service';

@Component({
  selector: 'app-login-status-message',
  imports: [SpenFlashMessage, SpenLink],
  templateUrl: './login-status-message.component.html',
  styleUrls: ['./login-status-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginStatusMessageComponent implements OnInit {
  private readonly loginStatusMessageService = inject(
    LoginStatusMessageService
  );
  private cdr = inject(ChangeDetectorRef);

  public show: boolean = false;
  public message: string | null = null;
  public showLink: boolean = false;
  public link: string | null = null;

  ngOnInit(): void {
    this.loginStatusMessageService.getLoginStatusMessage().then((json) => {
      if (!json) {
        return;
      }
      this.show = json.message !== null;
      this.message = json.message;
      this.showLink = json.link !== null;
      this.link = json.link;
      this.cdr.markForCheck();
    });
  }
}
